// extracted by mini-css-extract-plugin
export default {"container":"privacy_container__ppfFn","item":"privacy_item__bnLHH","subitem":"privacy_subitem__YACBJ","date":"privacy_date__oJSWC","point":"privacy_point__x1oLf"};